import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { Button } from "../../components/ui/button";
import Common from "../../helper/common";
import AdvanceTable from "../../components/advanceTable";
import { useNavigate } from "react-router-dom";
import { useQueryParams } from "../../contexts/queryParamsContext";
import {
    SearchTypeEnum,
} from "../../constants/appConstant";
import { AppSelect } from "../../components/appComponents";

const ClientUsers = () => {
    const [data, setData] = useState({});
    const [roleId, setRoleId] = useState(null);
    const [roleList, setRoleList] = useState([{ id: null, name: "All Roles" }]);
    const navigate = useNavigate();
    const { params, setParams } = useQueryParams();

    useEffect(() => {
        getData(1);
    }, [roleId]);

    useEffect(() => {
        getGLobalRoles();
    }, []);

    const getData = async (
        pageNumber,
        searchTerm = "",
        recordsToDisplay = null
    ) => {
        const response = await Common.ApiService.getInstance().request(
            "GetClientUsers",
            {
                pageNumber: pageNumber,
                q: searchTerm,
                isactive: true,
                roleId: roleId,
                recordsToDisplay,
            },
            "Post"
        );
        if (response?.data) {
            let obj = {
                ...response.data[0],
                data: response.data[0].data.map((item) => ({
                    ...item,
                    fullName: `${item.firstName} ${item.lastName}`,
                    status: item.isactive ? "Active" : "Inactive",
                    verification: item.isVerified ? "Verified" : "Unverified",
                })),
            };

            setData(obj);
        }
    };

    const _handleDelete = async (obj) => {
        const isConfirmed = await Common.SweetAlert.confirmation(
            "Are you sure you want to delete this user?",
            "Delete User"
        );
        if (isConfirmed) {
            let resp = await Common.ApiService.getInstance().request(
                `DeleteClientUser?id=${obj.id}`,
                {},
                "Delete"
            );
            Common.SweetAlert.alert(resp.message, "success");
            setTimeout(() => {
                getData(1);
            }, 500);
        }
    };

    const _thead = [
        { title: "Id", type: "number", isVisible: false, key: "id" },
        { title: "Name", type: "text", isVisible: true, key: "fullName" },
        { title: "Email", type: "text", isVisible: true, key: "email" },
        { title: "Role", type: "text", isVisible: true, key: "roleName" },
        { title: "RoleId", type: "number", isVisible: false, key: "roleid" },
        { title: "Type", type: "number", isVisible: false, key: "type" },
        {
            title: "Verification",
            type: "text",
            isVisible: true,
            key: "verification",
        },
        {
            title: "Status",
            type: "text",
            isVisible: true,
            key: "status",
        },
    ];

    const actions = [
        {
            type: "edit",
            onClick: (val) => {
                setParams({
                    ...params,
                    userId: val.id,
                });
                navigate("/app/addclientuser");
            },
        },
        {
            type: "delete",
            onClick: (val) => _handleDelete(val),
        },
    ];


    const getGLobalRoles = async () => {
        try {
            const response = await Common.ApiService.getInstance().request(
                `GetClientRoles`,
                "GET"
            );
            const data = [{ id: null, name: "All Roles" }, ...(response?.data ?? [])];
            setRoleList(data);
        } catch (err) {
            console.error("getRolesByClub error:", err);
            throw err;
        }
    };


    const resetFilters = () => {
        setRoleId(null);
    };

  const _addBtn = () => {
        return (
          <Button onClick={() =>
          {
            navigate("/app/addclientuser")}
          }
          >
            <span className="text-xl mr-1">
              <Icon icon="icon-park-outline:plus" />
            </span>
            Add User
          </Button>
        );
    };

    return (
        <>
            <div className="md:grid md:grid-cols-6 grid grid-cols-2 gap-x-2 mb-4">

                <AppSelect
                    value={roleId}
                    onChange={setRoleId}
                    placeholder="Select Role"
                    label="Role"
                    data={roleList}
                    className="mb-3 col-span-1"
                />

                <Button
                    className="h-8 w-fit hidden md:block"
                    style={{ marginTop: "22px" }}
                    onClick={resetFilters}
                >
                    Reset Filters
                </Button>
            </div>

            {data?.data && (
                <AdvanceTable
                    title={"Users"}
                    columns={_thead.filter((item) => item.isVisible)}
                    data={data}
                    getData={getData}
                    addButton={_addBtn}
                    showPagination
                    showAddButton
                    actionButtons={actions}
                    showExportoptions
                    search={SearchTypeEnum.Server_Search}
                    searchInputClassName="custom-search-mobile"
                />
            )}
        </>
    );
};
export default ClientUsers;